/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".newItem_fa6324c5{color:"},{"theme":"green","defaultValue":"#107c10"},{"rawString":";margin-right:3px}\n"}]);
export const newItem = "newItem_fa6324c5";